import React from 'react';
import { Bar } from 'react-chartjs-2';

const RentabiliteProjets = ({ budgets = [] }) => {
  // Si budgets est undefined ou null, on utilise un tableau vide par défaut
  const safeBudgets = budgets || [];

  const data = {
    labels: safeBudgets.map((b) => b.poste_budgetaire),
    datasets: [
      {
        label: 'Montant Prévu',
        data: safeBudgets.map((b) => b.montant_prevu),
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
      {
        label: 'Montant Réel',
        data: safeBudgets.map((b) => b.montant_reel),
        backgroundColor: 'rgba(255, 99, 132, 0.6)',
      },
    ],
  };

  // Optionnel : afficher un message si aucun budget n'est disponible
  if (safeBudgets.length === 0) {
    return <p>Aucune donnée de budget disponible pour ce projet.</p>;
  }

  return <Bar data={data} />;
};

export default RentabiliteProjets;
